import { render, staticRenderFns } from "./GameStartNewCharacter.vue?vue&type=template&id=39e6e634&scoped=true&"
import script from "./GameStartNewCharacter.vue?vue&type=script&lang=js&"
export * from "./GameStartNewCharacter.vue?vue&type=script&lang=js&"
import style0 from "./GameStartNewCharacter.vue?vue&type=style&index=0&id=39e6e634&scoped=true&lang=css&"
import style1 from "./GameStartNewCharacter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e6e634",
  null
  
)

export default component.exports